export type Article = {
  id?: string;
  title: string;
  summary: string;
  zakkaartje?: string;
  clinicalFeatures?: string;
  diagnosis?: string;
  differentialDiagnoses?: string;
  management?: string;
  microbiologicalFeatures?: string;
  epidemiology?: string;
  etiology?: string;
  category: string;
  subcategory?: string;
  imageUrls?: string[];
  sources?: string;
};

export type ExpandableField =
  | "summary"
  | "zakkaartje"
  | "clinicalFeatures"
  | "diagnosis"
  | "differentialDiagnoses"
  | "management"
  | "microbiologicalFeatures"
  | "epidemiology"
  | "etiology";

export const articleFields = [
  { name: "title", label: "Title", type: "text", required: true },
  { name: "category", label: "Category", type: "text", required: true },
  { name: "subcategory", label: "Subcategory", type: "text", required: false },
  { name: "summary", label: "Summary", type: "richtext", required: true },
  { name: "zakkaartje", label: "Zakkaartje", type: "richtext", required: false },
  { name: "etiology", label: "Etiology", type: "richtext", required: false },
  { name: "clinicalFeatures", label: "Clinical Features", type: "richtext", required: false },
  { name: "diagnosis", label: "Diagnosis", type: "richtext", required: false },
  { name: "differentialDiagnoses", label: "Differential Diagnosis", type: "richtext", required: false },
  { name: "management", label: "Management", type: "richtext", required: false },
  { name: "microbiologicalFeatures", label: "Microbiological Features", type: "richtext", required: false },
  { name: "epidemiology", label: "Epidemiology", type: "richtext", required: false },
  { name: "otherNotes", label: "Other Notes", type: "richtext", required: false },
  { name: "sources", label: "Sources", type: "richtext", required: false },
  // Add more fields as needed
];